module.exports = __webpack_public_path__ + "01ea978f/img/mini-logo.18817ee5.svg";